// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDXlCdTwKlx8EagiGLFjf7-Urad-kMn82U",
  authDomain: "delytour-heng.firebaseapp.com",
  projectId: "delytour-heng",
  storageBucket: "delytour-heng.firebasestorage.app",
  messagingSenderId: "853783169751",
  appId: "1:853783169751:web:06818353a7f4a3b9ac7e92",
  measurementId: "G-DN8PHFN76F"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

// Initialize Analytics (only in browser)
let analytics;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export { analytics };
export default app;
